// extracted by mini-css-extract-plugin
export default {"container":"HistoryResultDisplay_container__0ycsv","highlight":"HistoryResultDisplay_highlight__+uZ-j"};